module.exports = __webpack_public_path__ + "img/54.4b06d1ed.jpg";